{
  "title": "Python Developer",

  "profile_name": "Андрей Трофимов",

  "language": "Язык",

  "about_me": {
    "title": "Обо мне",
    "details": [
      "Python программист с многогранным опытом в Web разработке",
      "Использую накопившийся опыт, а также постигаю новые технологии и инструменты для реализации своих идей в мире клиент-серверных приложений"
    ]
  },

  "education": {
    "title": "Образование",
    "details": [
      "Бакалавр Информационных Технологий",
      "Пермский Государственный Университет",
      "Механико-математический факультет",
      "2009 - 2014"
    ]
  },

  "work_experience": {
    "title": "Опыт работы",
    "details": [
      {
        "title": "Inline Telecom Solutions",
        "icon": "inline-telecom-solutions",
        "link": "https://inlinetelecom.ru",
        "period": "2022 - …",
        "jobs": [
          {
            "title": "Web-разработка",
            "stack": ["Python", "JavaScript", "HTML", "CSS"]
          },
          {
            "title": "Разработка систем сбора и анализа данных для веб-маркетинга, систем анализа сетевой активности, учета ресурсов",
            "stack": ["Python", "Django", "PostgreSQL"]
          },
          {
            "title": "Поддержка и развитие проектов для сетей крупных операторов связи",
            "stack": ["Python", "Django", "Vue"]
          }
        ]
      },
      {
        "title": "Realiste",
        "icon": "realiste",
        "link": "https://realiste.io",
        "period": "2023 - 2024",
        "jobs": [
          {
            "title": "Разработка микросервисов автоматической обработки и интеллектуального анализа данных",
            "stack": ["Python", "HTML", "JavaScript", "Docker"]
          },
          {
            "title": "Создание геопространственных и аналитических ресурсов в сфере недвижимости",
            "stack": ["Python", "Docker"]
          },
          {
            "title": "Поддержка масштабируемых конвейеров анализа данных и ETL",
            "stack": ["Python", "Gitlab CI", "Docker"]
          }
        ]
      },
      {
        "title": "Самозанятый",
        "icon": "company-self-employed",
        "link": "https://interlark.ru",
        "period": "2018 - 2022",
        "jobs": [
          {
            "title": "Разработка решений под ключ: Web сайты и сервисы, Telegram боты, Blender плагины, мобильные приложения, парсеры и др.",
            "stack": ["Python", "JavaScript", "HTML", "CSS"]
          }
        ]
      },
      {
        "title": "ИВС",
        "icon": "company-ics",
        "link": "https://ivs-corp.ru",
        "period": "2016 - 2018",
        "jobs": [
          {
            "title": "Разработка и поддержка Web сервисов",
            "stack": ["ASP.NET", "C#", "PostgreSQL"]
          },
          {
            "title": "Написание, отладка и тестирование Web компонентов",
            "stack": ["HTML", "JavaScript", "C#"]
          },
          {
            "title": "Профилирование и оптимизация backend сервисов",
            "stack": [".NET", "Mono"]
          }
        ]
      },
      {
        "title": "Урал Гео",
        "icon": "company-uralgeo",
        "link": "https://уралгео.рф",
        "period": "2013 - 2015",
        "jobs": [
          {
            "title": "Разработка централизированного удаленного доступа данных ГИС",
            "stack": ["C++", "PostgreSQL"]
          },
          {
            "title": "Написание Windows Shell Extension",
            "stack": ["C++", "WinAPI"]
          },
          {
            "title": "Создание ГИС Web-ориентированных картографических проектов",
            "stack": ["HTML", "JavaScript", "Python"]
          }
        ]
      }
    ]
  },

  "projects": {
    "title": "Персональные проекты",
    "details": [
      {
        "title": "USTVGO IPTV",
        "icon": "project-ustvgo",
        "stack": ["Python", "Aiohttp", "Tkinter"],
        "link": "https://github.com/interlark/ustvgo-iptv",
        "description": "Кросплатформенное проксирующее трафик приложение, которое позволяет смотреть бесплатное цифровое телевидение используя известный сервис USTVGO.",
        "features_title": "Особенности",
        "features": [
          "Автоматическая ротация ключей аутентификации",
          "Встроенная автообновляемая телепрограмма",
          "Тёмная и светлая темы иконок",
          "GUI"
        ]
      },
      {
        "title": "SMS Poll",
        "icon": "project-smspoll",
        "stack": ["Python", "FastAPI", "Tortoise ORM", "ReactJS"],
        "link": "https://github.com/interlark/sms-poll",
        "description": "Android приложение, которое позволяет создать СМС-голосование с помощью телефона для вашей аудитории во время проведения соревнований, конференций и других мероприятий.",
        "features_title": "Особенности",
        "features": [
          "Не нуждается в подключении к ПК, Интернету или другим сторонним сервисам",
          "Тёмная и светлая UI темы"
        ]
      },
      {
        "title": "Parser 2GIS",
        "icon": "project-parser2gis",
        "stack": ["Python", "Tkinter", "CDP"],
        "link": "https://github.com/interlark/parser-2gis",
        "description": "Программа автоматического сбора базы адресов и контактов предприятий онлайн каталога 2GIS, полезна при проведении маркетиноговой аналитики, а также для поиска клиентской базы и деловых партнеров.",
        "features_title": "Особенности",
        "features": [
          "Успешно обходит анти-бот блокировки",
          "Удобный генератор ссылок по городам и рубрикам",
          "Экспорт в CSV таблицу или JSON список",
          "GUI"
        ]
      },
      {
        "title": "QDC Converter",
        "icon": "project-qdcconverter",
        "stack": ["Python", "Tkinter", "I18N"],
        "link": "https://github.com/interlark/qdc-converter",
        "description": "Десктопное приложение для конвертирования проприетарных бинарных карт Garmin Quickdraw™ в открытые форматы CSV таблиц и GRD растров.",
        "features_title": "Особенности",
        "features": [
          "Поддержка многопоточности для ускорения конвертации",
          "Выходные форматы: CSV таблица и GRD растр",
          "GUI"
        ]
      }
    ]
  },

  "interests": {
    "title": "Интересы",
    "details": [
      { "name": "Спорт", "icon": "running_man" },
      { "name": "Японский язык", "icon": "hiragana" },
      { "name": "Sega / NES", "icon": "sega-nes" },
      { "name": "Сhiptune", "icon": "note" },
      { "name": "ИБ", "icon": "shield" },
      { "name": "Arduino", "icon": "arduino" },
      { "name": "Путешествия", "icon": "plane" }
    ]
  },

  "certificates": {
    "title": "Сертификаты",
    "details": [
      {
        "name": "Методы и средства инженерии программного обеспечения",
        "url": "https://www.intuit.ru/verifydiplomas/101129630"
      },
      {
        "name": "Стандартизация и сертификация программного обеспечения",
        "url": "https://www.intuit.ru/verifydiplomas/101129880"
      },
      {
        "name": "Анализ требований к автоматизированным информационным системам",
        "url": "https://www.intuit.ru/verifydiplomas/101129804"
      },
      {
        "name": "Основы менеджмента программных проектов",
        "url": "https://www.intuit.ru/verifydiplomas/101129771"
      },
      {
        "name": "Проектирование информационных систем",
        "url": "https://www.intuit.ru/verifydiplomas/101129238"
      }
    ]
  },

  "contacts": {
    "title": "Контакты",
    "details": [
      {
        "icon": "email",
        "address": "interlark@gmail.com",
        "href": "mailto:interlark@gmail.com",
        "is_external": false
      },
      {
        "icon": "telegram",
        "address": "https://t.me/interlark",
        "href": "https://t.me/interlark",
        "is_external": true
      },
      {
        "icon": "phone",
        "address": "+7 (908) 277-77-63",
        "href": "tel:+79082777763",
        "is_external": false
      },
      {
        "icon": "github",
        "address": "https://github.com/interlark",
        "href": "https://github.com/interlark",
        "is_external": true
      }
    ]
  },

  "skills": {
    "title": "Навыки",
    "details": [
      { "name": "Python", "value": 95 },
      { "name": "JavaScript", "value": 90 },
      { "name": "HTML", "value": 85 },
      { "name": "CSS", "value": 85 },
      { "name": "SQL / PostgreSQL", "value": 80 },
      { "name": "Docker", "value": 80 },
      { "name": "C#", "value": 75 },
      { "name": ".NET", "value": 75 },
      { "name": "C", "value": 70 },
      { "name": "C++", "value": 70 },
      { "name": "Bash", "value": 70 },
      { "name": "Git", "value": 75 },
      { "name": "Inkscape", "value": 60 }
    ]
  },

  "tools": {
    "title": "Инструменты",
    "details": [
      { "name": "Django", "value": 90 },
      { "name": "FastAPI", "value": 85 },
      { "name": "Aiohttp", "value": 75 },
      { "name": "Flask", "value": 80 },
      { "name": "SQLAlchemy", "value": 75 },
      { "name": "Asyncio", "value": 75 },
      { "name": "Pytest", "value": 80 },
      { "name": "Flake8", "value": 90 },
      { "name": "Mypy", "value": 80 },
      { "name": "Tkinter", "value": 70 },
      { "name": "CDP", "value": 80 },
      { "name": "Selenium / Playwright", "value": 80 },
      { "name": "P4A", "value": 60 },
      { "name": "OpenCV", "value": 70 },
      { "name": "ReactJS", "value": 60 },
      { "name": "Chakra UI", "value": 60 },
      { "name": "Parcel", "value": 60 },
      { "name": "VSCode", "value": 90 },
      { "name": "Linux / Debian", "value": 90 }
    ]
  },

  "languages": {
    "title": "Языки",
    "details": [
      { "name": "Русский", "value": 100 },
      { "name": "Английский", "value": 85 },
      { "name": "Японский", "value": 15 }
    ]
  }
}
